<template>
  <div
    :class="[
      { 'as-statistic-home': isHomePage },
      `as-parent-statics as-parent-statics-${siteName}`,
    ]"
  >
    <div v-if="isShowTab"
      class="as-nav-tabs-btn as-nav-tabs-btn__border"
      :class="`as-nav-tabs-btn-${siteName}`"
    >
      <div
        class="as-nav-item"
        v-for="tab of statistics"
        :key="tab.id"
        :class="{ active: activeTab === tab.status_id }"
        @click="activeTab = tab.status_id"
      >
        <span class="as-extra-item"></span>
        {{ getTabLabel(tab.status_id) }}
      </div>
    </div>
    <div v-else>
      <StatisticsItem
        :statistics="dataDefault"
        :match="match"
        :isHomePage="isHomePage"
        :isDefault="true"
      />
    </div>
    <!-- <NoData v-else /> -->

    <div v-if="isShowTab" class="as-tab-content">
      <StatisticsItem
        v-for="statistic in statistics"
        :key="statistic?.id"
        v-show="activeTab === statistic.status_id"
        :statistics="statistic"
        :match="match"
        :isHomePage="isHomePage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed, watch } from "vue";
import type { IStatistics, IMatch } from "~src/interfaces/badminton";
import StatisticsItem from "~src/components/statistics/volleyball/StatisticsItem.vue";
import { getProcessedStats } from "~src/helpers/badminton/index";

import {
  // getProcessedStats,
  initializeData,
} from "~src/helpers/volleyball/index";
import MatchEnum from "~src/enums/volleyball/MatchEnum";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  statistics: IStatistics[];
  match: IMatch;
  isHomePage: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
});

const siteName = computed(() => commonStore.getSiteName);
const dataDefault = initializeData();
const activeTab = ref(0);

const statisticAll = computed<any>(() => {
  const data = props.statistics.length
    ? props.statistics[props.statistics.length - 1]
    : ({} as IStatistics);

  return data;
});

const isShowTab = computed(() => {
  if (!statisticAll.value || statisticAll.value.type === 100) {
    return false;
  }

  const stats = getProcessedStats(props.match, statisticAll.value, false);

  return stats.length > 0;
});

const getTabLabel = (type: number | string): string | null | undefined => {
  switch (type) {
    case 0:
      return "Tất cả";
    case MatchEnum.FIRST_SET:
      return "SET 1";
    case MatchEnum.SECOND_SET:
      return "SET 2";
    case MatchEnum.THIRD_SET:
      return "SET 3";
    case MatchEnum.FOURTH_SET:
      return "SET 4";
    case MatchEnum.FIFTH_SET:
      return "SET 5";
    default:
      return undefined;
  }
};
</script>
